import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Injector, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { AuthGuard } from '@app/shared/common/IDSVRAuthProviders/auth.guard.service';
import { AuthService } from '@app/shared/common/IDSVRAuthProviders/auth.service';
import { AppTimezoneScope, DefaultTimezoneScope } from '@shared/AppEnums';
import { AppComponentBase } from '@shared/common/app-component-base';
import { ClaimModifyServiceProxy, CurrentUserProfileEditDto, ModifyClaimDto, ProfileServiceProxy, UpdateGoogleAuthenticatorKeyOutput, UserClaimEditDto } from '@shared/service-proxies/service-proxies';
import * as moment from 'moment';
import { document, ModalDirective } from 'ngx-bootstrap';
import { Profile, User } from 'oidc-client';
import { Observable } from 'rxjs';
import { SmsVerificationModalComponent } from './sms-verification-modal.component';
import { FormControl, Validators } from '@angular/forms';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MyNeedsCalculatorService } from '@app/shared/common/widgets/my-needs-calculator-widget/my-needs-calculator.service';
import { AppConsts } from '@shared/AppConsts';


@Component({
    selector: 'mySettingsModal',
    templateUrl: './my-settings-modal.component.html',
    styleUrls: ['./my-settings-modal.component.css'],
})
export class MySettingsModalComponent extends AppComponentBase implements OnInit {
    occupations: any[] = [];
    occupationsLoadError = '';

    @ViewChild('mySettingsModal') modal: ModalDirective;
    @ViewChild('smsVerificationModal') smsVerificationModal: SmsVerificationModalComponent;

    @Input() editDetailType = 'all';
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    public active = false;
    public saving = false;
    public isGoogleAuthenticatorEnabled = false;
    public isPhoneNumberConfirmed: boolean;
    public isPhoneNumberEmpty = false;
    public smsEnabled: boolean;
    public user: CurrentUserProfileEditDto;
    public showTimezoneSelection: boolean = abp.clock.provider.supportsMultipleTimezone;
    public canChangeUserName: boolean;
    public defaultTimezoneScope: DefaultTimezoneScope = AppTimezoneScope.User;
    private _initialTimezone: string = undefined;
    currentUserInfo: Profile;
    clonedCurrentUserInfo: Profile;
    restrictionDateValue = new Date();
    GenderList: any = ['Male', 'Female', 'Non-binary'];
    selectedGender: any;
    restrictionMessage: any;
    nameDisabled: boolean;
    surnameDisabled: boolean;
    birthdayDisabled: boolean;
    genderDisabled: boolean;
    private wasInside = false;
    tabIndex: number;
    profile_contact_scheme: string;
    existsCurrentUserInfo: Profile;
    lastTabActive: boolean;
    schemeDisabled: boolean;
    existsRestrictionDateValue: Date;
    enabledField: boolean[] = [];

    occupationFormControl = new FormControl('', [Validators.required, Validators.maxLength(200)]);
    addressLine1FormControl = new FormControl('', [Validators.required, Validators.maxLength(200)]);
    addressLine2FormControl = new FormControl('', [Validators.maxLength(200)]);
    suburbFormControl = new FormControl('', [Validators.required, Validators.maxLength(50)]);
    cityFormControl = new FormControl('', [Validators.required, Validators.maxLength(50)]);
    postalCodeControl = new FormControl('', [Validators.required, Validators.maxLength(10), Validators.pattern(/^\d{3,10}$/)]);


    constructor(
        injector: Injector,
        private _profileService: ProfileServiceProxy,
        private _claimModifyService: ClaimModifyServiceProxy,
        private _needsCalculatorService: MyNeedsCalculatorService,
    ) {
        super(injector);
        this.getCurrentUserInfo();
    }

    getCurrentUserInfo() {
        abp.event.on('getExistsUserInfo', () => {
            this._authService.getUser((res: Profile) => {
                this.existsCurrentUserInfo = res;
                let utcDate = this.existsCurrentUserInfo.birthdate;
                this.existsRestrictionDateValue = moment(utcDate, 'DD/MM/YYYY hh:mm:ss A').toDate();
                this.setActiveCapture();
            });
        });
    }

    setActiveCapture() {
        if (this.editDetailType !== 'all') {
            switch (this.editDetailType) {
                case 'profile':
                this.show();
                    break;
                case 'contact':
                this.contactTab();
                    break;
                case 'scheme':
                this.schemeTab();
                    break;
                case 'other':
                this.otherTab();
                    break;
                }
            }
    }

    show(): void {
        this.active = true;
        this.restrictionMessage = false;
        this.lastTabActive = false;
        this.tabIndex = 1;
        this.profile_contact_scheme = 'profile';
        this.nameDisabled = true;
        this.surnameDisabled = true;
        this.genderDisabled = true;
        this.birthdayDisabled = true;
        this._authService.getUser((res: Profile) => {
            this.currentUserInfo = res;
            this.selectedGender = this.currentUserInfo.gender;
            let birthDate = this.currentUserInfo.birthdate;
            this.restrictionDateValue = moment(birthDate, 'DD/MM/YYYY hh:mm:ss A').toDate();
            abp.event.trigger('getExistsUserInfo');
            this.setFormControlInitialValues();
            this.clonedCurrentUserInfo = JSON.parse(JSON.stringify(this.currentUserInfo));
            this.modal.show();
        });
    }

    profileTab() {
        this.lastTabActive = false;
        this.schemeDisabled = true;
        this.profile_contact_scheme = 'profile';
        this.tabIndex = 1;

        if ((this.existsCurrentUserInfo as any).medical_scheme_membership_number !== (this.currentUserInfo as any).medical_scheme_membership_number) {

            this.changesConfirmPopup();
        } else {
            this.disabledField();
        }

    }

    contactTab() {
        this.nameDisabled = true;
        this.surnameDisabled = true;
        this.schemeDisabled = true;
        this.genderDisabled = true;
        this.birthdayDisabled = true;

        this.lastTabActive = false;
        this.profile_contact_scheme = 'contact';
        this.tabIndex = 2;

        if (((this.existsCurrentUserInfo as any).gender !== this.selectedGender)
            || ((this.existsCurrentUserInfo as any).family_name !== (this.currentUserInfo as any).family_name)
            || ((this.existsCurrentUserInfo as any).given_name !== (this.currentUserInfo as any).given_name)
            || this.existsRestrictionDateValue.getTime() !== this.restrictionDateValue.getTime()
            || ((this.existsCurrentUserInfo as any).medical_scheme_membership_number !== (this.currentUserInfo as any).medical_scheme_membership_number)) {

            this.changesConfirmPopup();
        } else {
            this.disabledField();
        }

    }

    schemeTab() {
        this.profile_contact_scheme = 'scheme';
        this.tabIndex = 3;
        this.lastTabActive = false;
        this.nameDisabled = true;
        this.surnameDisabled = true;
        this.schemeDisabled = true;
        this.genderDisabled = true;
        this.birthdayDisabled = true;

        if (((this.existsCurrentUserInfo as any).gender !== this.selectedGender)
            || ((this.existsCurrentUserInfo as any).family_name !== (this.currentUserInfo as any).family_name)
            || ((this.existsCurrentUserInfo as any).given_name !== (this.currentUserInfo as any).given_name)
            || this.existsRestrictionDateValue.getTime() !== this.restrictionDateValue.getTime()) {

            this.changesConfirmPopup();
        } else {
            this.disabledField();
        }

    }

    otherTab() {
        this.profile_contact_scheme = 'other';
        this.tabIndex = 4;
        this.lastTabActive = true;
        this.nameDisabled = true;
        this.surnameDisabled = true;
        this.schemeDisabled = true;
        this.genderDisabled = true;
        this.birthdayDisabled = true;

        if (this.currentUserInfo && (((this.existsCurrentUserInfo as any).occupation !== (this.currentUserInfo as any).occupation)
            || ((this.existsCurrentUserInfo as any).physical_address_city !== (this.currentUserInfo as any).physical_address_city)
            || ((this.existsCurrentUserInfo as any).physical_address_code !== (this.currentUserInfo as any).physical_address_code)
            || ((this.existsCurrentUserInfo as any).physical_address_line_1 !== (this.currentUserInfo as any).physical_address_line_1)
            || ((this.existsCurrentUserInfo as any).physical_address_line_2 !== (this.currentUserInfo as any).physical_address_line_2)
            || ((this.existsCurrentUserInfo as any).physical_address_suburb !== (this.currentUserInfo as any).physical_address_suburb))
        ) {
            this.changesConfirmPopup();
        } else {
            this.disabledField();
        }

    }

    changesConfirmPopup() {
        let d = this;
        abp.message.confirm('', 'Do you want to save profile changes before you continue?',
            function (isConfirmed) {
                if (isConfirmed) {
                    this._authservice.getUser((res: Profile) => {
                        d.currentUserInfo = res;
                        d.selectedGender = d.currentUserInfo.gender;
                        let birthDate = d.currentUserInfo.birthdate;
                        d.restrictionDateValue = moment(birthDate, 'DD/MM/YYYY hh:mm:ss A').toDate();
                        this.setFormControlInitialValues();
                    });
                } else {
                    d.save(null);
                }
            }, true
        );
        document.getElementsByClassName('swal2-confirm')[0].innerText = 'Continue without saving';
        document.getElementsByClassName('swal2-confirm')[0].classList.add('modal-button-clr');
        document.getElementsByClassName('swal2-confirm')[0].classList.add('border-radius-55');
        document.getElementsByClassName('swal2-confirm')[0].classList.add('font-size-12');


        document.getElementsByClassName('swal2-cancel')[0].innerText = 'Save';
        document.getElementsByClassName('swal2-cancel')[0].classList.add('modal-button-clr');
        document.getElementsByClassName('swal2-cancel')[0].classList.add('border-radius-55');
        document.getElementsByClassName('swal2-cancel')[0].classList.add('font-size-12');
    }

    disabledField() {
        this.nameDisabled = true;
        this.surnameDisabled = true;
        this.schemeDisabled = true;
        this.genderDisabled = true;
        this.birthdayDisabled = true;
    }

    updateQrCodeSetupImageUrl(): void {
        this._profileService.updateGoogleAuthenticatorKey().subscribe((result: UpdateGoogleAuthenticatorKeyOutput) => {
            this.user.qrCodeSetupImageUrl = result.qrCodeSetupImageUrl;
            this.isGoogleAuthenticatorEnabled = true;
        });
    }

    smsVerify(): void {
        //this._profileService.sendVerificationSms()
        //    .subscribe(() => {
        //        this.smsVerificationModal.show();
        //    });
    }

    changePhoneNumberToVerified(): void {
        this.isPhoneNumberConfirmed = true;
    }

    onShown(): void {
        document.getElementById('Name').focus();
    }

    close(): void {
        this.active = false;
        this.modal.hide();
    }

    ngOnInit() {
        this.addressLine1FormControl.valueChanges.subscribe(val => this.currentUserInfo.physical_address_line_1 = val);
        this.addressLine2FormControl.valueChanges.subscribe(val => this.currentUserInfo.physical_address_line_2 = val);
        this.suburbFormControl.valueChanges.subscribe(val => this.currentUserInfo.physical_address_suburb = val);
        this.cityFormControl.valueChanges.subscribe(val => this.currentUserInfo.physical_address_city = val);
        this.postalCodeControl.valueChanges.subscribe(val => this.currentUserInfo.physical_address_code = val);
        this.occupationFormControl.valueChanges.subscribe(val => this.currentUserInfo.occupation = val);

        this.loadOccupations();
    }

    private loadOccupations(): void {
        this._needsCalculatorService.getOccupationList().pipe(
            catchError(() => {
                const msg = this.l ? this.l('CouldNotLoadOccupations') : 'Failed to load occupations';
                this.occupationsLoadError = msg;
                abp.notify.error(msg);
                return of([]);
            })
        ).subscribe((res: any) => {
            if (Array.isArray(res) && res.length > 0) {
                this.occupations = res[0].Data || [];
            } else {
                this.occupations = [];
            }
        });
    }

    private setFormControlInitialValues() {
        if (!this.currentUserInfo) { return; }
        this.occupationFormControl.setValue(this.currentUserInfo.occupation || '');
        this.addressLine1FormControl.setValue(this.currentUserInfo.physical_address_line_1 || '');
        this.addressLine2FormControl.setValue(this.currentUserInfo.physical_address_line_2 || '');
        this.suburbFormControl.setValue(this.currentUserInfo.physical_address_suburb || '');
        this.cityFormControl.setValue(this.currentUserInfo.physical_address_city || '');
        this.postalCodeControl.setValue(this.currentUserInfo.physical_address_code || '');
    }

    private addClaim(claimList: ModifyClaimDto, claimType: string, claimValue: any): void {
        if (!claimList.userClaimEditDtos) {
            claimList.userClaimEditDtos = [];
        }
        const claim = new UserClaimEditDto();
        claim.claimType = claimType;
        claim.claimValue = claimValue === undefined || claimValue === null ? '' : claimValue;
        claimList.userClaimEditDtos.push(claim);
    }

    private getClaimValueFromControl(control: FormControl, propName: string): any {
        const val = control && control.value;
        if (val !== null && val !== undefined && val.toString().trim() !== '') {
            return val;
        }
        return (this.currentUserInfo as any)[propName] || '';
    }

    private hasOtherFieldsChanged(): boolean {
        if (!this.existsCurrentUserInfo) {
            return true;
        }

        const occupationChanged = (this.clonedCurrentUserInfo as any).occupation !== this.getClaimValueFromControl(this.occupationFormControl, AppConsts.ClaimTypes.occupation);
        const addressLine1Changed = (this.clonedCurrentUserInfo as any).physical_address_line_1 !== this.getClaimValueFromControl(this.addressLine1FormControl, AppConsts.ClaimTypes.physical_address_line_1);
        const addressLine2Changed = (this.clonedCurrentUserInfo as any).physical_address_line_2 !== this.getClaimValueFromControl(this.addressLine2FormControl, AppConsts.ClaimTypes.physical_address_line_2);
        const suburbChanged = (this.clonedCurrentUserInfo as any).physical_address_suburb !== this.getClaimValueFromControl(this.suburbFormControl, AppConsts.ClaimTypes.physical_address_suburb);
        const cityChanged = (this.clonedCurrentUserInfo as any).physical_address_city !== this.getClaimValueFromControl(this.cityFormControl, AppConsts.ClaimTypes.physical_address_city);
        const postalCodeChanged = (this.clonedCurrentUserInfo as any).physical_address_code !== this.getClaimValueFromControl(this.postalCodeControl, AppConsts.ClaimTypes.physical_address_code);

        return occupationChanged || addressLine1Changed || addressLine2Changed || suburbChanged || cityChanged || postalCodeChanged;
    }

    save(saveForm: string) {
        if (this.editDetailType === 'other') {
            this.addressLine1FormControl.markAsTouched();
            this.suburbFormControl.markAsTouched();
            this.cityFormControl.markAsTouched();
            this.postalCodeControl.markAsTouched();
            this.occupationFormControl.markAsTouched();
            this.addressLine2FormControl.markAsTouched();

            if (this.addressLine1FormControl.invalid || this.suburbFormControl.invalid || this.cityFormControl.invalid ||
                 this.postalCodeControl.invalid || this.occupationFormControl.invalid || this.addressLine2FormControl.invalid) {
                return;
            }
        }

        this.saving = true;
        this.saving = false;


        let claimList = new ModifyClaimDto();
        claimList.userClaimEditDtos = new Array<UserClaimEditDto>();
        abp.ui.setBusy();


        if (this.editDetailType === 'all') {
            this.addClaim(claimList, AppConsts.ClaimTypes.given_name, (this.currentUserInfo as any).given_name);
            this.addClaim(claimList, AppConsts.ClaimTypes.family_name, (this.currentUserInfo as any).family_name ? (this.currentUserInfo as any).family_name.toString() : '');
            this.addClaim(claimList, AppConsts.ClaimTypes.birthdate, moment(this.restrictionDateValue).format('DD/MM/YYYY hh:mm:ss A'));
            this.addClaim(claimList, AppConsts.ClaimTypes.gender, this.selectedGender);
            this.addClaim(claimList, AppConsts.ClaimTypes.medical_scheme_membership_number, (this.currentUserInfo as any).medical_scheme_membership_number);
        }

        if (this.editDetailType === 'all' || this.editDetailType === 'other') {
            if (this.hasOtherFieldsChanged()) {
                this.addClaim(claimList, AppConsts.ClaimTypes.occupation, this.getClaimValueFromControl(this.occupationFormControl, AppConsts.ClaimTypes.occupation));

                const selectedOccupation = this.occupations.find(o => (o.Title ? o.Title : o) === this.getClaimValueFromControl(this.occupationFormControl, AppConsts.ClaimTypes.occupation));
                const occupationCategory = selectedOccupation && selectedOccupation.Description
                    ? selectedOccupation.Description.replace(/\s+/g, '_')
                    : undefined;

                if (occupationCategory) {
                    this.addClaim(claimList, AppConsts.ClaimTypes.occupation_category, occupationCategory);
                }

                this.addClaim(claimList, AppConsts.ClaimTypes.physical_address_line_1, this.getClaimValueFromControl(this.addressLine1FormControl, AppConsts.ClaimTypes.physical_address_line_1));
                this.addClaim(claimList, AppConsts.ClaimTypes.physical_address_line_2, this.getClaimValueFromControl(this.addressLine2FormControl, AppConsts.ClaimTypes.physical_address_line_2));
                this.addClaim(claimList, AppConsts.ClaimTypes.physical_address_suburb, this.getClaimValueFromControl(this.suburbFormControl, AppConsts.ClaimTypes.physical_address_suburb));
                this.addClaim(claimList, AppConsts.ClaimTypes.physical_address_city, this.getClaimValueFromControl(this.cityFormControl, AppConsts.ClaimTypes.physical_address_city));
                this.addClaim(claimList, AppConsts.ClaimTypes.physical_address_code, this.getClaimValueFromControl(this.postalCodeControl, AppConsts.ClaimTypes.physical_address_code));
            }

            if (this.editDetailType === 'other') {
                const now = moment().format('DD/MM/YYYY hh:mm:ss A');

                if (this.hasOtherFieldsChanged() || this.currentUserInfo.occupation_confirmation_date === undefined || this.currentUserInfo.occupation_confirmation_date === null || this.currentUserInfo.occupation_confirmation_date === '') {
                    this.addClaim(claimList, AppConsts.ClaimTypes.occupation_confirmation_date, now);
                }

                if (this.hasOtherFieldsChanged() || this.currentUserInfo.address_confirmation_date === undefined || this.currentUserInfo.address_confirmation_date === null || this.currentUserInfo.address_confirmation_date === '') {
                    this.addClaim(claimList, AppConsts.ClaimTypes.address_confirmation_date, now);
                }
            }
         }

        claimList.accessToken = this._authService.user.access_token;
        claimList.userId = (this.currentUserInfo as any).sub;

        this._claimModifyService.modifyClaim(claimList).subscribe(() => {
            abp.event.trigger('updateProfileName');
            if (this.editDetailType === 'other' && this.hasOtherFieldsChanged()) {
                //Send notification email to support team for verification of other details when other details are edited
                this._emailService.sendGenericCustomerSupportMail({
                    subject: `Occupation and address verified - ${claimList.userId}`,
                    contentTitle: 'Occupation and address verified'.toUpperCase(),
                    firstName: this.currentUserInfo.given_name,
                    lastName: this.currentUserInfo.family_name,
                    emailAddress: this.currentUserInfo.email,
                    cellNumber: this.currentUserInfo.phone_number.toString(),
                    content: `The occupation and/or address details for ${this.currentUserInfo.given_name} ${this.currentUserInfo.family_name} have been updated and need to be verified.  New details are as follows: <br/><br/>
                    Occupation: <b>${this.getClaimValueFromControl(this.occupationFormControl, AppConsts.ClaimTypes.occupation)}</b> <br/>
                    Physical Address Line 1: <b>${this.getClaimValueFromControl(this.addressLine1FormControl, AppConsts.ClaimTypes.physical_address_line_1)}</b> <br/>
                    Physical Address Line 2: <b>${this.getClaimValueFromControl(this.addressLine2FormControl, AppConsts.ClaimTypes.physical_address_line_2)}</b> <br/>
                    Physical Address Suburb: <b>${this.getClaimValueFromControl(this.suburbFormControl, AppConsts.ClaimTypes.physical_address_suburb)}</b> <br/>
                    Physical Address City: <b>${this.getClaimValueFromControl(this.cityFormControl, AppConsts.ClaimTypes.physical_address_city)}</b> <br/>
                    Physical Address Postal Code: <b>${this.getClaimValueFromControl(this.postalCodeControl, AppConsts.ClaimTypes.physical_address_code)}</b> <br/>`,
                    toAddress: abp.setting.values['SupportEmail.To'],
                    userId: claimList.userId,
                }).subscribe(res => {
                    this.lastTabActive ? this.saveContinueSubmit('SavedSuccessfully', null) : this.saveContinueSubmit('ChangesSavedSuccessfully', saveForm);
                    console.log('Notification email sent for other details verification.');
                });
            } else {
                this.lastTabActive ? this.saveContinueSubmit('SavedSuccessfully', null) : this.saveContinueSubmit('ChangesSavedSuccessfully', saveForm);
            }
        }, (error) => {
            abp.ui.clearBusy();

            console.log(error);
        });

    }

    saveContinueSubmit(value, saveForm: string) {
        if (value === 'SavedSuccessfully') {
            this.notify.info(this.l('SavedSuccessfully'));
            abp.ui.clearBusy();
            this.close();
        } else {
            this.notify.info(this.l('ChangesSavedSuccessfully'));
            if (saveForm != null) {
                if (this.tabIndex !== 4) {
                    this.tabIndex = this.tabIndex + 1;
                }

                // tslint:disable-next-line: no-unused-expression
                this.tabIndex === 4 ? this.lastTabActive = true : null;
                this.nameDisabled = true;
                this.surnameDisabled = true;
                this.schemeDisabled = true;
                this.genderDisabled = true;
                this.birthdayDisabled = true;
            }

            abp.event.trigger('getExistsUserInfo');
            abp.ui.clearBusy();
        }
        this.modalSave.emit(null);
    }

    onValueChange(value: Date): void {
        let restrictionyear = new Date().getFullYear() - 18;
        let selectedFullyear = value != null ? value.getFullYear() : null;
        if (selectedFullyear >= restrictionyear) {
            this.restrictionMessage = true;
            this.saving = true;
        } else {
            this.restrictionMessage = false;
            this.saving = false;
        }
    }

    onChange(value: any) {
        if (value === '') {
            this.restrictionMessage = false;
        }
        this.restrictionDateValue = value;

    }

    edit(value: any) {

        this.nameDisabled = true;
        this.surnameDisabled = true;
        this.schemeDisabled = true;
        this.genderDisabled = true;
        this.birthdayDisabled = true;
        this._authService.getUser((res: Profile) => {
            this.currentUserInfo = res;
            this.selectedGender = this.currentUserInfo.gender;
            let birthDate = this.currentUserInfo.birthdate;
            this.restrictionDateValue = moment(birthDate, 'DD/MM/YYYY hh:mm:ss A').toDate();
        });

        switch (value) {
            case 'name': this.nameDisabled = false;
                break;
            case 'surname': this.surnameDisabled = false;
                break;
            case 'birthday': this.birthdayDisabled = false;
                break;
            case 'gender': this.genderDisabled = false;
                break;
            case 'scheme': this.schemeDisabled = false;
                break;
        }
    }
}
